// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
// ANTD
import Tag from 'antd/lib/tag';
// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';

const clientCol = {
  title: 'CLIENT',
  dataIndex: 'client._id',
  key: 'client._id',
  render: (text, record) => {
    if (record.client && record.client.firstName && record.client.lastName) {
      return (
        <Link to={`/app/clients/${record.client._id}`}>
          {record.client.firstName} {record.client.lastName}
        </Link>
      );
    }
  },
};

const statusCol = {
  title: 'STATUS',
  dataIndex: 'status',
  key: 'status',
  render: (text, record) => {
    switch (record.status) {
    case 'DRAFT':
      return <Tag>DRAFT</Tag>;
    case 'SENT':
      return <Tag color="yellow">SENT</Tag>;
    case 'PAID':
      return <Tag color="green">PAID</Tag>;
    default:
      return null;
    }
  },
};

export const MOBILE_COLUMNS = [
  {
    title: 'NUMBER',
    dataIndex: 'number',
    key: 'number',
  },
  clientCol,
  statusCol,
];

export const FULL_SCREEN_COLUMNS = [
  {
    title: '#',
    dataIndex: 'number',
    key: 'number',
  },
  clientCol,
  {
    title: 'PAYMENT',
    dataIndex: 'paidAt',
    key: 'paidAt',
    render: (text, record) => {
      if (record.paidAt) {
        return <span>{GeneralHelpers.formatTableDate(record.paidAt)} </span>;
      }
      return <Tag>UNPAID</Tag>;
    },
  },
  {
    title: 'SENT',
    dataIndex: 'sentAt',
    key: 'sentAt',
    render: (text, record) => {
      if (record.sentAt) {
        return <span>{GeneralHelpers.formatTableDate(record.sentAt)} </span>;
      }
    },
  },
  statusCol,
];



// WEBPACK FOOTER //
// ./src/routes/app-home/InvoicesTable/columns.js